// extracted by mini-css-extract-plugin
export default {"bg":"Home_bg__q6HRL"};